import { RelocationOrderStatus } from "@/api-schema-enums";

export function isBranchRejectedStatus(status: RelocationOrderStatus): boolean {
  return status.startsWith("Branch_Rejected_");
}

export function isTransportCompanyRejectedStatus(status: RelocationOrderStatus): boolean {
  return status.startsWith("Transport_Company_Rejected_");
}
